import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=5ffe2ed8"
import script from "./FormCheckbox.vue?vue&type=script&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=5ffe2ed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports